import { Writeable } from "../types/Writeable";

export function unlocked<T>(value: T): Writeable<T> {
  return value as Writeable<T>;
}

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

export function isDefined<T>(variable: T | undefined): variable is T {
  return typeof variable !== "undefined";
}
